import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteCustomFormat($id: ID!) {
    deleteCustomFormat(id: $id) {
      id
    }
  }
`;

export const deleteCustomFormat = async (id) => {
  const variables = {
    id,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp(result.data);
};
